import Cookie from '@wtdc/cookie';

export default Cookie;

